export default "__VITE_ASSET__CHvVD2a8__"